import navigatorStore from '../stores/navigatorStore'


export function validateIfInputIsEmail(input) {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(input)) {
        navigatorStore.openErrorModal("Email is not valid.")
        return false;
    }
    return true;
}

export function validateIfInputHasSpaces(input) {
    // console.log("[input]",input)
    if (input.includes(" ")) {
        return false;
    }
    return true;
}

export function validateInputLength(input, minLength, maxLength) {
    if (input.length < minLength) {
        return false;
    }
    if (input.length > maxLength) {
        return false;
    }
    return true;

}

export function validateIfInputHasEmail(input){
        var re = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
        return re.test(input);
}


export function validateIfInputHasCharacters(input){
    var format = /[ !@#$%^&*()+\-=\[\]{};':"\\|,<>\/?]/;
    return format.test(input)
}
export function validateIfInputHasCharactersAllowSpaces(input){
    var format = /^[0-9a-zA-Z \b]+$/;
    // var key =  String.fromCharCode(!event.charCode ? event.which: event.charCode)
    return format.test(input)
}


export function validateIfInputHasUpperCaseLetter(input){
   
        return (/[A-Z]/.test(input));
    
}

export function validateIfInputHasYourMasterpieces(input){
if(input.includes("yourmasterpieces")){
    return true;
}
if(input.includes("ymp")){
    return true;
}
if(input.includes("masterpieces")){
    return true;
}
return false;
}

export function validateIfInputHasTenDigits(input){
  let re=  /(^|\D)\d{10}($|\D)/

  return re.test(input)
}

export function validateIfInputHasUrl(input) {
    var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
    if(!regex.test(input)) {
    //     this.props.navigatorStore.openErrorModal("Please enter valid URL.");
      return true;
    } else {
      return false;
    }
  }


// WEBPACK FOOTER //
// ./src/helpers/validationChecks.js